export const menuPermission = {
  marketing: 'marketing',
  integrations: 'integrations',
  analytics: 'analytics',
  reports: 'reports',
}
